import { of } from 'rxjs';

import { buildImpedanceModelings } from './impedance';
import {
  calculateTotalPressedThickness,
  calculateTotalThickness
} from './thickness';

function simulate(payload) {
  const { layers } = payload;
  console.log('running simulation...', layers); // eslint-disable-line no-console

  const thickness = calculateTotalThickness(layers);
  const pressedThickness = calculateTotalPressedThickness(layers);
  const impedanceModelings = buildImpedanceModelings(layers);

  return of({
    impedanceModelings,
    pressedThickness,
    thickness,
  });
}

export default simulate;



// WEBPACK FOOTER //
// ./src/lib/simulations/simulations.js